import { FormItemProps } from '@/components/Form/types'
import * as Yup from 'yup'

import React from 'react'
import FontStylesForm from '@/components/FontManager/Components/FontStylesForm'
import FontStylesList from '@/components/FontManager/Components/FontStylesList'
import FontPreviewForm from '@/components/FontManager/Components/FontPreviewForm'
import languageList from './../mapData/languageList'

const Items: Array<FormItemProps> = [

	{
		name: 'id',
		type: 'Hidden',
	},

	{
		name: 'fontFamily',
		label: 'Family Name',
		type: 'Text',
		placeholder: 'Enter family name (e.g., Roboto, Open Sans)',
		help: 'Enter the customer-facing font family name. All uploaded styles, such as Regular and Bold, are grouped under this name.',
		validation: Yup.string().required('Required'),
		classNames: {
			container: 'col-span-6 break-line',
		},
		autoFocus: true,

	},
	{
		name: 'language',
		label: 'Language',
		type: 'Select',
		help: 'Choose the language or writing system this font is intended to support. Use All Languages only when the font has the required characters for every supported audience.',
		itemOptions: {
			list: languageList
		},
		defaultValue : {value: ''},
		classNames: {
			container: 'col-span-6 break-line',
		}
	},
	{
		name: 'active',
		label: 'Active (Visible to users)',
		type: 'Checkbox',
		help: 'Turn this on to make the font available to customers. Turn it off to keep the font and its styles saved without showing them in the design experience.',
		defaultValue: true,
		classNames: {
			container: 'col-span-12',
		},
	},
	{
		type: 'Divider',
		name: 'divider1',
		label: 'Styles',
		classNames: {
			container: 'col-span-12',
		},
	},
	{
		name: 'fontStyle',
		label: 'Styles',
		type: 'Preview',
		itemOptions: {
			preview: (props: any) => (
				<FontStylesList {...props} />
			),
		},
		defaultValue: [],
		classNames: {
			container: 'col-span-12',
			label: 'hidden',
		},
		validation: Yup.array().min(1, 'At least one style is required'),
	},
	{
		name: 'newFontStyle',
		type: 'Preview',
		itemOptions: {
			preview: (props: any) => (
				<FontStylesForm {...props} />
			),
		},
		classNames: {
			container: 'col-span-12',
		},
	},
	{
		type: 'Divider',
		name: 'divider2',
		label: 'Font Preview',
		classNames: {
			container: 'col-span-12',
		},
		condition: data => (data?.fontStyle?.length > 0),
	},
	{
		name: 'preview',
		type: 'Preview',
		itemOptions: {
			preview: (props: any) => (
				<FontPreviewForm {...props} />
			),
		},
		classNames: {
			container: 'col-span-12',
		},
		condition: data => (data?.fontStyle?.length > 0),
	},
	{
		name: 'previewStyle',
		type: 'Hidden',
		classNames: {
			label: 'hidden',
		},
	},
]


export default Items;
